import React from 'react';

export default class QuoteReviewWarning extends React.PureComponent {

  render() {
    const {  show } = this.props;
    return (
      show && <div className="alert alert-warning d-flex">
            <div className="justify-content-start ms-2">
                <i className="fa fa-info-circle fa-lg text-danger"></i>
            </div>
            <div className="justify-content-start align-self-center ms-3">
            This quote has custom instructions that need to be approved before a purchase order can be submitted.
            <br />You will be contacted via email as soon as the quote has been approved.
            </div>
          </div>
    )
  }
}
